import { render, staticRenderFns } from "./wo002Detail02.vue?vue&type=template&id=0bde85ee"
import script from "./wo002Detail02.vue?vue&type=script&lang=js"
export * from "./wo002Detail02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bde85ee')) {
      api.createRecord('0bde85ee', component.options)
    } else {
      api.reload('0bde85ee', component.options)
    }
    module.hot.accept("./wo002Detail02.vue?vue&type=template&id=0bde85ee", function () {
      api.rerender('0bde85ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/imsi/sample/wo002Detail02.vue"
export default component.exports